import React from "react";
import { Dropdown, Icon, Menu, Modal, Tab, List } from "semantic-ui-react";
import { dispatch } from '@rematch/core';
import { ChangePassword } from "../profile/ChangePassword";
import { UserDetails } from "../profile/UserDetails";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { source } from 'react-aim';
import ImageAvater from "../../drive/Components/ImageAvater";
import { history } from "../../../helpers";
@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext("User Image")

  }
})

class UserNav extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  handleOpen = async () => {
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.lifeCycle.showResourecePane(null);
    dispatch.profile.modalOpen(true);
    dispatch.lifeCycle.setLibraryCardIndex(null);
  }

  handleClose = () => {
    dispatch.profile.modalOpen(false);
  }

  platformRedirect = () => {
    dispatch.app.setCurrentContext("platform");
    this.props.history.push("/app/platform");
  }

  workspaceRedirect = () => {
    // let user = this.props.user;
    let organizations = this.props.organizations;
    let userHasOrgs = organizations && organizations.length > 0;
    if (userHasOrgs) {
      dispatch.app.setCurrentContext("workspace/home");
      this.props.history.push("/app/workspace/home");
    } else {
      dispatch.app.setCurrentContext("noworkspace");
      this.props.history.push("/app/noworkspace");
    }
  }

  goToHome = () => {
    let path = ''

    if (this.props.selectedAccount.isPlatformAccount) {
        path = '/app/platform/home'
    }
    else {
        path = '/app/' + this.props.selectedAccount._id + '/dashboard'
    }
    history.push({
        pathname: path
    });
  }

  goToConsumptionDetails = () => {
    history.push({
        pathname: '/app/' + this.props.selectedAccount._id + '/settings/consumptionDetails'
    });
  }

  viewAllAccount = async () => {
    await dispatch.account.setViewAccountFlag(true);

  }

  render() {

    let user = this.props.user;
    let onLogout = this.props.onLogout;
    let context = this.props.context;
    let isPlatformUser = user.isPlatformUser;
    let showSwithOption = isPlatformUser;
    let isInPlatformContext = context === "platform";

    const { selectedAccount } = this.props
    let selectedAccountInUser = user && user.accounts && user.accounts.length > 0 && user.accounts.filter(account => { return account && selectedAccount && selectedAccount._id && account.id.toString() === selectedAccount._id.toString() });
    const isCustomerAdmin = selectedAccountInUser && selectedAccountInUser.length > 0 && selectedAccountInUser[0].role === "customerAdmin" && !selectedAccount.isPlatformAccount;
    const trigger = (
      <List className="userData" style={{ margin: '-2px' }}>
        <List.Item>
          <ImageAvater user={this.props.user} className="pad_tb_9" />
        </List.Item>
      </List>
    );

    const inlineStyle = {
      modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };

    const panes = [
      {
        menuItem:
          (<Menu.Item name='User Details'> <Icon style={{ float: 'left' }} size='large' name='address card' />User Details</Menu.Item>),
        render: () => <Tab.Pane style={{ minHeight: '200px' }}><UserDetails></UserDetails></Tab.Pane>
      },
      {
        menuItem:
          (<Menu.Item name='Change Password'> <Icon style={{ float: 'left' }} size='large' name='key' />Change Password</Menu.Item>),
        render: () => <Tab.Pane style={{ minHeight: '200px' }}><ChangePassword></ChangePassword></Tab.Pane>
      },
      {
        menuItem:
          (<Menu.Item name='Notification Settings'> <Icon style={{ float: 'left' }} size='large' name='bell' />Notification Settings</Menu.Item>),
        render: () => <Tab.Pane style={{ minHeight: '200px' }}><Icon className="centeredHugeIcon" size='huge' name='bell' /></Tab.Pane>
      },
      {
        menuItem:
          (<Menu.Item name='Privacy Settings'> <Icon style={{ float: 'left' }} size='large' name='shield' />Privacy Settings</Menu.Item>),
        render: () => <Tab.Pane style={{ minHeight: '200px' }}><Icon size='huge' className="centeredHugeIcon" name='shield' /></Tab.Pane>
      },
    ]
    return (
      <div style={{ border: "0px", borderLeft: "1px solid #e5e5e5" }}>

        <Dropdown size="large" trigger={trigger} item className="userDataDropdown" >
          <Dropdown.Menu>
            <Dropdown.Item icon="user circle" text="My Profile" onMouseEnter={() => dispatch.app.setHelpContext("User Profile")} onClick={this.handleOpen} />
            <Dropdown.Item icon="shield" text="View Account" onClick={this.viewAllAccount} ></Dropdown.Item>
            <Dropdown.Item onClick={this.goToHome}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{marginRight:'0.8rem',marginLeft:"0.4rem", display:"inline-block"}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 68.268 54.622">
                    <path d="M23.894,27.307A13.654,13.654,0,1,0,10.24,13.654,13.654,13.654,0,0,0,23.894,27.307Zm-4.875,5.12A19.015,19.015,0,0,0,0,51.446a3.168,3.168,0,0,0,3.168,3.168H44.619a3.38,3.38,0,0,0,.565-.053c-8.139-5.877-10.645-15.04-11-21.355a18.887,18.887,0,0,0-5.408-.779Zm32.939-8.352-12.8,5.12a2.573,2.573,0,0,0-1.611,2.379c0,6.752,2.763,18.006,14.379,22.848a2.534,2.534,0,0,0,1.973,0c11.605-4.843,14.368-16.1,14.368-22.848A2.573,2.573,0,0,0,66.657,29.2l-12.8-5.12A2.541,2.541,0,0,0,51.958,24.075ZM63.084,33.28c-.416,5.408-2.9,12.448-10.176,15.968V29.206Z"
                      fill="#373737" />
                  </svg>
                </span>
                Account Home
              </div>
            </Dropdown.Item>
            {isCustomerAdmin && <Dropdown.Item onClick={this.goToConsumptionDetails}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{marginRight:'0.8rem',marginLeft:"0.2rem", display:"inline-block"}}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v2H2V7z"/>
                    <path d="M2 11h20v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-6z"/>
                  </svg>
                </span>
                Billing & Usage
              </div>
            </Dropdown.Item>}

            {showSwithOption && isInPlatformContext ? <Dropdown.Item onClick={this.workspaceRedirect} >Workspace</Dropdown.Item> : null}
            {showSwithOption ? <Dropdown.Divider /> : null}
            <Dropdown.Item icon="power" text="Log Out" onClick={onLogout} />
          </Dropdown.Menu>
        </Dropdown>

        <Modal
          size='small'
          open={this.props.isModalOpen}
          centered
          closeOnEscape={false}
          closeOnDimmerClick={false}
          className="userDataDropdownModal basicModal"
          style={{ ...inlineStyle.modal, zIndex: "99999" }}
          onClose={this.handleClose}
          closeIcon
        >
          <Modal.Header >My Profile</Modal.Header>
          <Modal.Content className="pad_0">
            <Modal.Description>
              <Tab className="myProfile" menu={{ vertical: true }} grid={{ paneWidth: 11, tabWidth: 5 }}
                panes={panes} />
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    isModalOpen: state.profile.isModalOpen,
    allAccounts: state.account.allAccounts
  };
}

const connectedUserNav = withRouter(connect(mapStateToProps)(UserNav));
export { connectedUserNav as UserNav }; 